import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { ModalBody as BaseModalBody } from 'reactstrap';
import BaseModal from '@paradigm/design-system/src/components/Modal';
import { richBlack } from '@paradigm/design-system/src/colors';
import LeaderboardProvider from '@paradigm/features/src/leaderboard/contexts/leaderboard';
import Tabs, {
  LeaderboardTabContent,
} from '#/components/Leaderboard/LeaderboardTabs';
import MyFirm from '#/components/Leaderboard/MyFirm';
import { HeaderSection } from '#/components/Leaderboard/LeaderboardHeader';
import useKeybinding from '#/hooks/useKeybinding';
import { trackAction } from '@paradigm/logging/src/logging';

const SHORTCUT_KEY = 'F1';

export default function LeaderboardModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [openTimeMs, setOpenTimeMs] = useState<number | null>(null);
  const open = useCallback(() => {
    if (!isOpen) setOpenTimeMs(Date.now());

    setIsOpen(true);
  }, [isOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
    if (openTimeMs == null) return;
    const timeDiff = (Date.now() - openTimeMs) / 1_000;

    trackAction('F1 press: Leaderboard modal was viewed', {
      duration: timeDiff,
    });
  }, [openTimeMs]);

  useKeybinding(SHORTCUT_KEY, open, close);

  return (
    <LeaderboardProvider>
      <Modal isOpen={isOpen} aria-label="leaderboard modal">
        <ModalHeader>
          <HeaderSection>
            <h5 className="modal-title">Leaderboard</h5>
            <Tabs />
          </HeaderSection>
          <HeaderSection>
            <MyFirm />
          </HeaderSection>
        </ModalHeader>
        <ModalBody>
          <LeaderboardTabContent />
        </ModalBody>
      </Modal>
    </LeaderboardProvider>
  );
}

const Modal = styled(BaseModal)`
  .modal-content {
    background-color: ${richBlack};
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  gap: 1rem;
`;

const ModalBody = styled(BaseModalBody)`
  > div {
    margin: 0;
  }
`;
